(ns common.schema.entities.workspace.kyc.kyc-risk-category
  (:require [common.schema.schema-utils :as su]))

(def schema
  (vec (concat (su/text-simple-field :kyc-risk-category/name "Name" {:name-attribute :kyc-risk-category/name})
               (su/integer-field :kyc-risk-category/renewal-interval "Renewal interval (years)" {}))))
